// extracted by mini-css-extract-plugin
export default {"container":"NoItems_container__TtTbn","title":"NoItems_title__nwqCj","description":"NoItems_description__bRkxr"};